import script from "./HelpPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpPopover.vue?vue&type=script&setup=true&lang=js"

import "./HelpPopover.vue?vue&type=style&index=0&id=67c5a620&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c5a620"]])

export default __exports__